import React, { Component } from 'react'
import Projectdetail from "./Projectdetail";
import Imagerow from "./components/Imagerow";
import Updates from "./components/Projupdates";

export class MassNow extends Component {
  render() {
    return (
      <React.Fragment>
        <Projectdetail
          image="assets/img/herobg-proj-detail-massmow-2.jpg"
          heading="MassNow News"
          content={[
            <>
              <p>
                This is a SEO multi user news site similar to Masslive.com. Some of the features of this project include but not limited to JWT based Authentication System, Role Based Authorization
                System, full CRUD capabilities with image uploading capabilities.
              </p>

              <ul className="features">
                <li>Utilizes the MERN stack with Next.js, Cloudinary for cloud storage of images, and a WYSIWYG editor</li>
                <li>Uses a JWT based Authentication System, as well as a Role-Based Authorization System</li>
                <li>Full CRUD, and image uploading capabilities for multiple users</li>
                <li>
                  CRUD capabilities can also be role-based, for instance, Admins would have the ability to have full CRUD capabilities with regards to any blogs, but authors would only have this
                  ability regarding only the blogs they have created.
                </li>
                <li>Commenting system for each article, with replies for each comment. Users would need to be registered</li>
                <li>Ability to bookmark an article</li>
                <li>Live search for an article</li>
              </ul>
            </>,
          ]}
          website="https://massnow-news.netlify.app/"
          github="https://github.com/Jimmyelvis/massnow-frontend"
          techs={[
            <>
              <li>JavaScript</li>
              <li>React.js</li>
              <li>Next.js</li>
              <li>Node.js</li>
              <li>MongoDB</li>
              <li>Cloudinary</li>
              <li>Open Weather API</li>
            </>,
          ]}
          updates={[
            <>
              <h2 className="heading-2">Recent Updates</h2>

              <div className="updates">
                <Updates
                  heading="UPDATE 11/6/2022"
                  desc={[
                    <>
                      <p>
                        There has been several updates added, which includes but is not limited to, a complete redesign of the Admin dashboard area. Also those whose role is either an Author, or Admin
                        will be able to view all the comments associated with the site and view details of that comment such as, who replied, how many replies, and the article that the comment is
                        associated with. There has also been a small redesign to the Local News section, on the homepage.
                      </p>

                      <p>Lastly, all users will have the ability view all the articles that they have bookmarked. Useful for those who are looking to read a particular article at a later point.</p>
                    </>,
                  ]}
                  itemImage={[
                    {
                      fullimage: "assets/img/screenshots/lrg/rettretrtret.jfif",
                      screenshot: "assets/img/screenshots/lrg/rettretrtret.jfif",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/cbvcbvcncn.jfif",
                      screenshot: "assets/img/screenshots/lrg/cbvcbvcncn.jfif",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/rerwtwte.jpg",
                      screenshot: "assets/img/screenshots/lrg/rerwtwte.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/456646546.jfif",
                      screenshot: "assets/img/screenshots/lrg/456646546.jfif",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/gdgdsgdggsdg.jpg",
                      screenshot: "assets/img/screenshots/lrg/gdgdsgdggsdg.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/nbvvnbvn.jfif",
                      screenshot: "assets/img/screenshots/lrg/nbvvnbvn.jfif",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/crrw.jpg",
                      screenshot: "assets/img/screenshots/lrg/crrw.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/jgfjgfjgfj.jpg",
                      screenshot: "assets/img/screenshots/lrg/jgfjgfjgfj.jpg",
                    },
                  ]}
                  gallery="11/6/2022"
                />

                <Updates
                  heading="UPDATE 7/28/2022"
                  desc={[
                    <>
                      <p>
                        There has been several updates added, which includes but is not limited to, the ability to choose which articles that an administrator would want to feature in a news section
                        using a frontend ui interface. For instance on the home page you have a hero section that features a main cover story as well as four other highlighted stories in that section.
                        Now those who has a role of admin will have to ability to determine which stories will be highlighted in that section.
                      </p>

                      <p>
                        Also admins, and authors have the ability in the admin section to use a filtering system if needed to filter/sort through articles if for instance they would need to edit or
                        delete an article.
                      </p>
                    </>,
                  ]}
                  itemImage={[
                    {
                      fullimage: "assets/img/screenshots/lrg/edit-topnews-section.jpg",
                      screenshot: "assets/img/screenshots/lrg/edit-topnews-section.jpg",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/filters.jfif",
                      screenshot: "assets/img/screenshots/lrg/filters.jfif",
                    },
                    {
                      fullimage: "assets/img/screenshots/lrg/slected-story.jpg",
                      screenshot: "assets/img/screenshots/lrg/slected-story.jpg",
                    },
                    {
                      video: "yes",
                      fullimage: "https://youtu.be/TZllLBkfP7w",
                      screenshot: "assets/img/screenshots/lrg/vlcsnap-2022-08-07-15h12m18s964.jpg",
                    },
                    {
                      video: "yes",
                      fullimage: "https://youtu.be/6wx4suVDruU",
                      screenshot: "assets/img/screenshots/lrg/vlcsnap-2022-08-07-15h22m12s702.jpg",
                    },
                    {
                      video: "yes",
                      fullimage: "https://youtu.be/tVaNhh3Swnc",
                      screenshot: "assets/img/screenshots/lrg/filters.jfif",
                    },
                  ]}
                  gallery="3/15/2022"
                />
              </div>
            </>,
          ]}
          images={[
            <>
              <Imagerow images="assets/img/screenshots/lrg/5591df02-df78-4383-b69c-92ba64cfda80.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/2e6eb567-196a-485b-b9e6-cf376c3f02ad.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/5312f5c8-a87f-4336-8c40-25d2d203c3c1.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/4a846e70-91c0-4efd-894d-b017598a69ef.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/d25f4b68-6f60-4e4d-9382-84b23b3101bf.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/85774e09-7965-4007-b415-6053a71c1bc6.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/339b08e4-a544-4217-a5e8-2c297a9fed33.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/b69ac430-b498-46df-9bd3-9a9f265dc2e1.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/6a44c0c0-efe5-4528-bc43-97c16369af8f.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/5f9a7e97-bb09-4391-a01e-74ef8b10ad77.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/dcf264c1-387c-4cf3-a297-315ddb59535d.jpg" />

              <Imagerow images="assets/img/screenshots/lrg/eb285416-6e1c-4c22-b8bb-27f73b9263e9.jpg" />
            </>,
          ]}
        />
      </React.Fragment>
    );
  }
}

export default MassNow
